import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Algerian() {
  return (
    <ApiCommunityDirectoryPage
      community="Algerian"
      eyebrow="Algerian community guide"
      title="Algerian favorites, businesses, and local essentials in San Antonio."
      
      tags={["Algerian community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Algerian community guide?"
      modalIdPrefix="algerian-directory"
    />
  );
}
